module.exports = __webpack_public_path__ + "img/CM2SF.33c16e41.png";